<div class="success-notice">
  <div class="header-container">
    <app-svg-icon src="./assets/icons/success-status-icon.svg"></app-svg-icon>
    <div class="ep-text-primary-text ep-text-strong-18 header-text">{{ header }}</div>
  </div>
  <div class="ep-text-secondary-text ep-text-regular-14 text">{{ text }}</div>
</div>
